import useIntl from '@afosto/utils-react/intl/useIntl';
import capitalize from '@afosto/utils/string/capitalize';

const OrderTypeFormatter = ({ type }) => {
  const intl = useIntl();

  if (!type) {
    return '-';
  }

  return intl.formatMessage({
    id: `orderTypeOptions.${type}`,
    defaultMessage: capitalize(type ?? ''),
    description: `order type ${type}`,
  });
};

export default OrderTypeFormatter;
